/** Example paste formats for Import build list onboarding */

export const IMPORT_FORMAT_EXAMPLES = {
  simpleList: `Engine
- Manley 9:1 Pistons
- Bosch 84mm Throttle Body

Wheels and Tires
- Desmond Regamaster EVO II
  - 18x9.5 +22`,

  bulletList: `- Garrett GT2860RS Turbo Kit
- AEM Wideband O2 Sensor
- Tomei Expreme Ti Exhaust`,

  csv: `Part,Cost,Date,Vendor
Cold Air Intake,299.99,01/15/2024,K&N
Coilovers,1200.00,03/02/2024,BC Racing
Catback Exhaust,850.00,03/02/2024,HKS`,

  receipt: `INVOICE #48291
2 x K&N Filter - $45.99
1 x Exhaust Gasket - $12.00
Subtotal: $57.99
Tax: $4.64
Total: $62.63`,
} as const;

export type ImportFormatExampleKey = keyof typeof IMPORT_FORMAT_EXAMPLES;

/** Internal-only labels — do not show in primary UI. */
export const PARSE_SOURCE_LABELS: Record<string, string> = {
  json: 'Export file',
  ai: 'Organized',
  ai_fallback: 'Organized (offline)',
  rules: 'Organized',
};
